<template>
  <thux-table
    :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll('id')"
    @check-none="checkNone('id')"
    @set-selected-row="setSelectedRow($event, 'id')"
    :show-checks="showChecks"
    :showDetailButton="showDetailButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-detail-form="$emit('open-detail-form', $event)"
  >
    <template slot="color" slot-scope="{ item }">
      <span class="priority-color-cell" v-if="item.color">
        <span
          class="priority-color-cell__chip"
          :style="{ backgroundColor: item.color }"
          :title="item.color"
          aria-hidden="true"
        ></span>
        <span class="priority-color-cell__hex">{{ String(item.color).toLowerCase() }}</span>
      </span>
      <span v-else class="priority-color-cell priority-color-cell--empty">
        <span class="priority-color-cell__chip priority-color-cell__chip--empty" aria-hidden="true"></span>
        <span class="priority-color-cell__hex text-muted">—</span>
      </span>
    </template>
  </thux-table>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as TASK_PRIORITY_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'TaskPriorityTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      fields: [
        {
          key: 'checks',
          label: this.$t('Checks')
        },
        {
          key: 'status',
          label: this.$t('Status'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'status'
        },
        {
          key: 'code',
          label: this.$t('Code'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'code'
        },
        {
          key: 'name',
          label: this.$t('Name'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'name'
        },
        {
          key: 'color',
          label: this.$t('Color'),
          custom: true,
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: false,
          value: 'color'
        },
        {
          key: 'level',
          label: this.$t('Level'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'level'
        },
        {
          key: 'action',
          label: this.$t('Actions'),
          tdClass: 'text-right text-nowrap',
          thClass: 'text-right text-nowrap'
        }
      ],
      fieldsColumn: ['status', 'code', 'name', 'color', 'level'],
      fieldName: 'id'
    }
  },
  computed: {
    ...mapGetters({
      selectAll: TASK_PRIORITY_TYPES.GENERIC.task['task-priority'].LIST.GETTERS.selectAll,
      selectedList: TASK_PRIORITY_TYPES.GENERIC.task['task-priority'].LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showDetailButton () {
      return hasPerm('tasks_taskpriority_retrieve')
    }
  },
  methods: {
    ...mapMutations({
      setList: TASK_PRIORITY_TYPES.GENERIC.task['task-priority'].LIST.MUTATIONS.setList,
      setSelectedList:
        TASK_PRIORITY_TYPES.GENERIC.task['task-priority'].LIST.MUTATIONS.setSelectedList,
      setSelectAll: TASK_PRIORITY_TYPES.GENERIC.task['task-priority'].LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...TASK_PRIORITY_TYPES.GENERIC.task['task-priority'].LIST.ACTIONS
    })
  }
}
</script>
